import { Component } from "react"
import PropTypes from 'prop-types'
import Dialog from "material-ui/Dialog"
import { Row, Col } from "react-flexbox-grid"
import StyledModalRenegociacaoComposicaoCarga from "./modal-renegociacao-composicao-carga.styled"
import intl from 'react-intl-universal'
import { formatErrorMessage } from 'utils/handle-error';
import DateInput from "../../../../components/date-input"
import { renegociarComposicaoCarga } from './modal-renegociacao-composicao-carga.service'
import Message from 'components/message';
import Session from 'utils/user-storage';
import Loading from "components/center-loading"
import Input from "components/input"
import TextArea from "components/textarea"
import Button from "components/button"
import { fetchSuggestionsJustifications } from "services/suggestion/suggestion.service"
import { SelectBox } from "components/uikit-adapter"

class ModalRenegociacaoComposicaoCarga extends Component {
  constructor() {
    super();
    this.state = {
      dataEntregaSugerida: '',
      horaEntregaSugerida: '',
      observacaoSugerida: '',
      showMsg: false,
      textMsg: '',
      titleMsg: '',
      requestCount: 0,
      justification: null,
      justifications: []
    }
  }

  componentDidMount() {
    this.loadInitialData();
  }

  loadInitialData = async () => {
    try {
      this.handleFetch();
      const _justifications = await this.loadJustifications();

      this.setState({
        dataEntregaSugerida: this.props.composicaoCarga.DataEntrega,
        horaEntregaSugerida: this.props.composicaoCarga.HoraEntrega,
        observacaoSugerida: this.props.composicaoCarga.Observacao,
        justifications: _justifications
      });
    } catch (error) {
      this.showMessageRetorno(formatErrorMessage(error));
    } finally {
      this.handleFetch(false);
    }
  }

  loadJustifications = async () => {
    const _justifications = await fetchSuggestionsJustifications();
    return _justifications;
  }

  handleChangeValue = (name, value) => {
    this.setState({
      [name]: value
    }
    )
  }

  handleFetch = (isFetching = true) => {
    this.setState(prevState => ({
      requestCount: isFetching ? prevState.requestCount + 1 : prevState.requestCount - 1,
    }))
  }

  handleRenegociarComposicaoCarga = async () => {
    try {
      this.handleFetch();

      if (this.validateFields()) {
        const user = Session.get()

        const negociacaoComposicaoCarga = {
          LoadCompositionId: this.props.composicaoCarga.IdComposicao,
          SuggestedDeliveryDate: this.state.dataEntregaSugerida,
          SuggestedDeliveryTime: this.state.horaEntregaSugerida,
          SuggestedObservation: this.state.observacaoSugerida,
          UserId: user.Id,
          TypeJustificationManualSuggestion: this.state.justification
        }

        await renegociarComposicaoCarga(this.props.composicaoCarga.IdComposicao, negociacaoComposicaoCarga);
        this.showMessageRetorno(intl.get('commons.renegotiationLoadCompositionSent'))

        this.setState({
          handleClose: () => {
            this.setState({ showMsg: false })
            this.props.toggleOpenModalRenegociacaoComposicaoCarga()
            this.props.closeModalDetalhamentoComposicao()
          }
        })
      }
    }
    catch (error) {
      this.showMessageRetorno(formatErrorMessage(error))
    }
    finally {
      this.handleFetch(false);
    }
  }

  validateFields = () => {
    let isValid = true

    const { dataEntregaSugerida, horaEntregaSugerida, observacaoSugerida, justification } = this.state
    const { DataEntrega, HoraEntrega, Observacao } = this.props.composicaoCarga

    if (dataEntregaSugerida === DataEntrega && horaEntregaSugerida === HoraEntrega && observacaoSugerida === Observacao) {
      this.showMessageRetorno(intl.get('commons.youNeedToFillAtLeastOneFieldToNegotiateTheOrder'))
      isValid = false
    } else if (!justification) {
      this.showMessageRetorno(intl.get('feedbacks.messageMandatoryJustification'))
      isValid = false
    }

    return isValid
  }

  showMessageRetorno = (data) => {
    this.setState({
      showMsg: true,
      titleMsg: intl.get("composition.form.note"),
      textMsg: data,
      handleClose: () => {
        this.setState({ showMsg: false })
      }
    })
  }

  render() {
    const {
      dataEntregaSugerida,
      horaEntregaSugerida,
      observacaoSugerida,
      requestCount,
      justification,
      justifications
    } = this.state

    const {
      openModalRenegociacaoComposicaoCarga,
      toggleOpenModalRenegociacaoComposicaoCarga,
      composicaoCarga,
    } = this.props;

    return (
      <>
      <Dialog
        autoScrollBodyContent
        title={`${intl.get('commons.negotiationLoadComposition')} - ${composicaoCarga.IdComposicao}`}
        contentStyle={{ width: "600px" }}
        open={openModalRenegociacaoComposicaoCarga}
        onRequestClose={toggleOpenModalRenegociacaoComposicaoCarga}
      >
        <StyledModalRenegociacaoComposicaoCarga
        data-testid='modal-renegotiation-load-composition'>
          <Row>
            <Col xs={6} lg={6} md={6}>
              <DateInput
                id='data-entrega-sugerida'
                label={intl.get('modalRenegotiationLoadComposition.suggestedDeliveryDate')}
                value={dataEntregaSugerida}
                placeholder={intl.get('modalRenegotiationLoadComposition.suggestedDeliveryDate')}
                onChange={(date) => this.handleChangeValue('dataEntregaSugerida', date)}
              />
            </Col>
            <Col xs={6} lg={6} md={6}>
              <Input
                id='hora-entrega-sugerida'
                htmlType='time'
                label={intl.get('modalRenegotiationLoadComposition.suggestedDeliveryTime')}
                value={horaEntregaSugerida}
                placeholder={intl.get('modalRenegotiationLoadComposition.suggestedDeliveryTime')}
                onChange={event => this.handleChangeValue('horaEntregaSugerida', event.target.value)}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} lg={12} md={12}>
              <TextArea
                data-testid='load-composition-negotiate-observation-suggested'
                id='observacao-sugerida'
                label={intl.get('modalRenegotiationLoadComposition.negotiationNotes')}
                value={observacaoSugerida || ''}
                onChange={(event) => this.handleChangeValue('observacaoSugerida', event.target.value)}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} lg={12} md={12}>
              <SelectBox
                name='justification'
                label={intl.get('commons.justification')}
                placeholder={intl.get('stocks.suggestionsListItem.justification')}
                value={justification}
                options={justifications}
                onChange={value => this.handleChangeValue('justification', value.Key)}
                valueKey='Key'
                labelKey='Value'
                className='select-justification'
                searchable
                openOnFocus
              />
            </Col>
          </Row>

          <div className="footer-dialog-buttons">
            <Button
              id='button-close'
              buttonType="default"
              value={intl.get('geral.buttonsDefault.cancel')}
              onClick={toggleOpenModalRenegociacaoComposicaoCarga}
              className="button cancel"
              disabled={requestCount > 0}
            />
            <Button
              id='button-renegociar-composicao-carga'
              buttonType="primary"
              value={intl.get('geral.buttonsDefault.send')}
              onClick={this.handleRenegociarComposicaoCarga}
              className="button send"
              disabled={requestCount > 0}
            />
          </div>
        </StyledModalRenegociacaoComposicaoCarga>
        <Message
          show={this.state.showMsg}
          text={this.state.textMsg}
          title={this.state.titleMsg}
          handleClose={this.state.handleClose}
        />
      </Dialog >      
      <Loading fullHeightParent isLoading={requestCount > 0} />
      </>
    )
  }
}

ModalRenegociacaoComposicaoCarga.propTypes = {
  closeModalDetalhamentoComposicao: PropTypes.func.isRequired,
  composicaoCarga: PropTypes.object.isRequired,
  openModalRenegociacaoComposicaoCarga: PropTypes.bool.isRequired,
  toggleOpenModalRenegociacaoComposicaoCarga: PropTypes.func.isRequired
}

export default ModalRenegociacaoComposicaoCarga;
